import { render, staticRenderFns } from "./mention.vue?vue&type=template&id=ba942edc&"
import script from "./mention.vue?vue&type=script&lang=js&"
export * from "./mention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports